export default {
  fetchAdminLoginSuccess: 'fetchAdminLoginSuccess',
  AdminlogOutSuccess: 'AdminlogOutSuccess',
};
